import Dashboard from '@/components/Dashboard'

export default {
    path: '/dashboard',
    name: 'Dashboard',
    alias: '/',
    component: Dashboard,
    meta: {requiresAuth: true}
}